import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ConfigurationAcceleratorsService } from './configuration-accelerators.service';
import { ConfigurationAcceleratorsTab1Part } from './tabs/tab-1/configuration-accelerators-tab-1.part';
import { ConfigurationAcceleratorsTab2Part } from './tabs/tab-2/configuration-accelerators-tab-2.part';
import { ConfigurationAcceleratorsViewsPart } from './views/accelerators-views.part';

@Component({
	selector: 'configuration-accelerators-page',
	standalone: true,
	imports: [
		ConfigurationAcceleratorsTab1Part,
		ConfigurationAcceleratorsTab2Part,
		ConfigurationAcceleratorsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget,
		DroplistWidget,
		ToolbarWidget,],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './configuration-accelerators.page.html',
})
export class ConfigurationAcceleratorsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: ConfigurationAcceleratorsService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}